// extracted by mini-css-extract-plugin
export default {"container":"container__-7fdd59bf","title":"title__-7fdd59bf","total":"total__-7fdd59bf","label":"label__-7fdd59bf","amount":"amount__-7fdd59bf"};